import ManagerInternalAccount from './ManagerInternalAccount.container';

export default ManagerInternalAccount;
